import { useBlockProps } from '@wordpress/block-editor';
import { isEmpty } from 'lodash';
import classnames from 'classnames';
import { getBlockClassNames } from '@components/class-dropdown';
import parse from 'html-react-parser';
import getIcons from './icons';
import { DEFAULT_CSS_CLASS } from '@constants';

const Save = ({ attributes }) => {
  const {
    blockClassNames,
    rotate,
    flipHorizontal,
    flipVertical,
    blockVisibility,
    iconExtension,
    icon,
    iconName,
    width,
    enableWidth,
  } = attributes;

  // set block classes and set to blockProps
  let classes = getBlockClassNames(blockClassNames);
  const iconClasses = classnames({
    [`rotate-${rotate}`]: rotate,
    'flip-horizontal': flipHorizontal,
    'flip-vertical': flipVertical,
    disable: !blockVisibility,
  });

  if (iconClasses) {
    classes = `${classes} ${iconClasses}`;
  }

  const iconStyles = enableWidth ? { width: `${width}px` } : null;

  //Get All icons
  const allIcons = getIcons();
  const namedIcon = allIcons.filter((i) => i.name === iconName);
  const printedIcon = !isEmpty(namedIcon) ? namedIcon[0].icon : '';

  let renderContent = '';
  if (icon) {
    renderContent = parse(icon);
  } else if (!isEmpty(iconExtension) && iconName) {
    renderContent = <img src={iconName} alt="" />;
  } else if (iconName) {
    renderContent = printedIcon;
  }

  return (
    <div
      {...useBlockProps.save({
        className: `${DEFAULT_CSS_CLASS.ICON} ${classes}`,
      })}
      style={iconStyles}
    >
      {renderContent}
    </div>
  );
};

export default Save;
